
import { mapActions, mapGetters } from "vuex";
import Form from "./Form.vue";
import PosData from "./PosData";

export default {
  name: "app-pos-update",
  data() {
    return {
      pos: {},
    };
  },
  components: {
    Form,
  },
  methods: {
    ...mapActions(["setLoading"]),
    async getPos(id_configuracao_pos) {
      try {
        const { data } = await this.$http.post("/pos/find", {
          id_configuracao_pos: id_configuracao_pos,
        });
        return data;
      } catch (error) {
        return null;
      }
    },
    async getInit() {
      try {
        const codigo = this.$route.params.id_configuracao_pos;

        this.setLoading(true);

        const pos = await this.getPos(codigo);

        this.setLoading(false);

        if (!pos.id_configuracao_pos || pos == null) {
          this.$router.push({ name: "posLista" });
          return this.$toast.error("Pos não encontrado!");
        }

        this.pos = new PosData(pos);
      } catch {
        return;
      }
    },
  },
  computed: {
    ...mapGetters(["itsblocked"]),
  },
  mounted() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
    this.getInit();
  },
};
